import classNames from 'classnames';
import { Skeleton } from '@medifind/shared-basic-components';
import styles from './HighlyRatedBlock.module.scss';

const HighlyRatedBlock = ({ className, count, doctor }) => {
  return (
    <>
      {!doctor || count ? (
        <div className={classNames(styles['num-highly-rated-conditions'], className)}>
          <div className={styles['text']}>{count ? 'Expertise in' : <Skeleton count={1} />}</div>
          <div className={styles['number']}>{count ? count : <Skeleton count={1} />}</div>
          <div className={styles['text']}>{count ? 'conditions' : <Skeleton count={1} />}</div>
        </div>
      ) : null}
    </>
  );
};

export { HighlyRatedBlock as default, HighlyRatedBlock };
